"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestMethod;
(function (RequestMethod) {
    RequestMethod[RequestMethod["DELETE"] = 0] = "DELETE";
    RequestMethod[RequestMethod["GET"] = 1] = "GET";
    RequestMethod[RequestMethod["HEAD"] = 2] = "HEAD";
    RequestMethod[RequestMethod["OPTIONS"] = 3] = "OPTIONS";
    RequestMethod[RequestMethod["PATCH"] = 4] = "PATCH";
    RequestMethod[RequestMethod["POST"] = 5] = "POST";
    RequestMethod[RequestMethod["PUT"] = 6] = "PUT";
})(RequestMethod || (RequestMethod = {}));
exports.default = RequestMethod;
//# sourceMappingURL=RequestMethod.js.map